module.exports = __webpack_public_path__ + "img/sell_out.2218faf9.svg";